module.exports = __webpack_public_path__ + "img/tuin terras.82dff71e.svg";